<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelChanges()">{{ 'GLOBAL.FORM.CANCEL' | translate }}</ion-button>
        </ion-buttons>
        <ion-title class="sub-headline-bold">{{ title }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="confirmChanges()" [disabled]="isConfirmDisabled()">
                {{ 'GLOBAL.FORM.VALIDATE' | translate }}
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content style="--padding-top: 0.8rem; --padding-bottom: 2.4rem">
    <div class="time-range-container">
        <div class="time-range-item">
            <div class="time-range-item__label">
                <ion-label class="body-medium">{{ 'COMPONENTS.MODAL_TIME_RANGE_PICKER.START' | translate }}</ion-label>
                <span class="number-regular">{{ timeRange().start }}</span>
            </div>
            <ion-datetime
                presentation="time"
                hourCycle="h23"
                [value]="type === 'edit' ? timeRange().start : ''"
                (ionChange)="onTimeChange('start', $event)"
            ></ion-datetime>
        </div>
        <div class="time-range-item">
            <div class="time-range-item__label">
                <ion-label class="body-medium">{{ 'COMPONENTS.MODAL_TIME_RANGE_PICKER.END' | translate }}</ion-label>
                <span class="number-regular">{{ timeRange().end }}</span>
            </div>
            <ion-datetime
                presentation="time"
                hourCycle="h23"
                [value]="type === 'edit' ? timeRange().end : ''"
                (ionChange)="onTimeChange('end', $event)"
            ></ion-datetime>
        </div>
    </div>
</ion-content>
